import {CategoryStreamSkeletonMobile} from '@aboutyou/logic-components';
import {lazy} from '@aboutyou/lazy-imports';
import React from 'react';

export const CouponLandingPage = lazy(
  () =>
    import('./CouponLandingPage.eager').then(mod => ({
      default: mod.CouponLandingPageEager,
    })),
  {
    fallback: <CategoryStreamSkeletonMobile />,
    aboveTheFold: true,
  },
);
